import { Table } from 'antd'
import { useQuery } from '@apollo/client'
import { Link, useNavigate } from 'react-router-dom'
import {Top} from '../../components/Top'
import { useState, useEffect } from 'react'
import { useUser } from '../../utils/hooks'
import { FIND_MANY_COUNTRY } from '../../gqls/country'

const limit = 50
const Country = () => {
  const { user } = useUser()
  const navigate = useNavigate()
  const [skip, setSkip] = useState(0)

  useEffect(() => {
    if (!user?.role?.canReview) navigate(-1)
  })

  const { data, loading } = useQuery(FIND_MANY_COUNTRY, {
    fetchPolicy: 'network-only',
    variables: { take: limit, skip },
  })

  const onChangeTable = (pagination) => {
    setSkip((pagination.current - 1) * limit)
  }

  const record = data ? data?.findManyCountry : []
  const total = data ? data?.findManyCountry.length : 0
  const columns = [
    {
      title: 'Заголовок',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Описание',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Язык',
      dataIndex: 'locale',
      key: 'locale',
    },
    {
      title: 'Валюта',
      dataIndex: 'currency',
      key: 'currency',
    },
  ]

  if (user?.role?.canObject) {
    columns.push({
      title: 'Действие',
      key: 'operation',
      align: 'center',
      render: (record) => {return <div style={{display:"flex", flexDirection:"column", justifyContent:"space-between", height:50}}><Link to={`/country/update/${record.id}`}>Изменить</Link><Link to={`/cities/${record.id}`}>Города</Link></div>},
    })
  }

  const getButtons = () => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {user?.role?.canReview && <Link to={`/country/create`}>Добавить</Link>}
    </div>
  )

  return (
    <>
      <Top title='Страны' action={getButtons()} />
      <Table
        dataSource={record}
        loading={loading}
        onChange={onChangeTable}
        pagination={{
          total,
          pageSize: limit,
        }}
        scroll={{ x: 600 }}
        rowKey={(row) => row.id}
        columns={columns}
      />
    </>
  )
}

export default Country
